import * as React from 'react';

const styles = require('./OptInScene.scss');
const classNames = require('classnames/bind').bind(styles);

export interface SceneProps {
    sceneName: string;
    artwork: JSX.Element;
    prose: JSX.Element;
    current: boolean;
}

function Scene(props: SceneProps) {
    return (
        <div className={classNames('frame')}>
            <div className={classNames('artwork')} aria-hidden={true}>
                <div className={classNames('scene-overlay')} />
                <div
                    className={classNames('scene', props.sceneName, {
                        'ready-to-animate': props.current,
                    })}>
                    {props.artwork}
                </div>
            </div>
            <article className={classNames('prose')}>
                <div className={classNames('descriptive-texts')}>{props.prose}</div>
            </article>
        </div>
    );
}
export default Scene;
